<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Пользователи</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-field>
            <b-select v-model="filters.is_active" placeholder="Filter by State" @input="pageChange()">
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearState()">X</button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Роль">
          <b-field>
            <b-select v-model="filters.role_id" placeholder="Filter by Role" @input="pageChange()">
              <option
                v-for="option in roles"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearRole()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order">
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          
          <b-table-column field="date" label="Дата регистрации" sortable>
            {{ props.row.date }}
          </b-table-column>

          <b-table-column field="email" label="Email" sortable>
            {{ props.row.email }}
          </b-table-column>

          <b-table-column field="password" label="Пароль" sortable>
            {{ props.row.password }}
          </b-table-column>
          
          <b-table-column field="role_id" label="Роль" sortable>
            {{ humanRole(props.row.role_id) }}
          </b-table-column>

          <b-table-column field="is_active" label="Состояние" sortable>
            {{ humanState(props.row.is_active) }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)" style="margin-right: .35rem;">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" @click="changePassword(props.row.id)" style="margin-right: .35rem;">
                <b-icon icon="key" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" @click="dropRow(props.row.id)" v-if="props.row.default != true">
                <b-icon icon="trash" type="is-danger" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import { EventBus } from '@/utils'
export default {
  name: "UserTable",
  data() {
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const data = []
    const roles = []
    const states = [
      {
        id: true,
        name: "Активный пользователь"
      },
      {
        id: false,
        name: "Не активный пользователь"
      }
    ]
    return {
      data: data,
      roles: roles,
      states: states,
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        is_active: null,
        role_id: null,
        order: 'asc',
        limit: 25
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('getUsers')
      .then(response => {
        let data = response.data;
        this.total = data.total
        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })

    this.$store.dispatch('getRoles')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.roles.push(item)
        })
      })
      .catch(error => {
        this.roles = []
      })
    
    EventBus.$on('successCreateUser', (data) => {
      this.data.push(data)
    })

    EventBus.$on('failedCreateUser', (msg) => {
      this.$toast.open({
        message: `${$this.$i18n.t('admin.create_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })

    EventBus.$on('successUpdateUser', () => {
      this.pageChange()
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successCreateUser')
    EventBus.$off('failedCreateUser')
    EventBus.$off('successUpdateUser')
  },
  methods: {
    humanRole: function(value){
      let name = this.roles.filter(function(role) {
        return role.id === value;
      })
      .map(function(role) {
        return role.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return "Роль не назначена"
      }
    },
    humanState: function(value){
      let name = this.states.filter(function(state) {
        return state.id === value;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return "Не активный: По умолчанию"
      }
    },
    add(item){
      EventBus.$emit("showModal", "user.add", null)
    },
    editRow(item){
      EventBus.$emit("showModal", "user.edit", item)
    },
    changePassword(item){
      EventBus.$emit("showModal", "user.password", item)
    },
    dropRow(id) {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.user_delete_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          $this.$store.dispatch('deleteUser', id)
          this.pageChange()
        }
      })
    },
    clearState(){
      this.filters.is_active = null
      this.pageChange()
    },
    clearRole(){
      this.filters.role_id = null
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
     
      this.$store.dispatch('getPageUsers', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>